module.exports = __webpack_public_path__ + "static/media/light-switch.b88a4468.svg";